module.exports = __webpack_public_path__ + "1308c0bbe171f99f6c22d7e373bd2281.png";